import { CorporateLifecycleApi, EnumLifecycleStep } from '@blank/api'

export const getIsKycComplete = (lifecycle?: CorporateLifecycleApi | null) => {
  if (!lifecycle) {
    return false
  }
  return lifecycle?.KYCStepStatus
    ? Object.values(lifecycle.KYCStepStatus).every((stepStatus) => {
        return (
          stepStatus === EnumLifecycleStep.DONE ||
          stepStatus === EnumLifecycleStep.DISABLED
        )
      })
    : false
}
